var _defs, _title, _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogoText = function SvgLogoText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 858.7 167"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _title || (_title = /*#__PURE__*/React.createElement("title", null, "logo-just-text")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.8,180.7l-.2-96.8L99.1,163.7H82.3L35,86v94.7H0V19.3H30.9L91.3,119.6,150.8,19.3h30.5l.5,161.4Z",
    transform: "translate(0 -16.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.9,100c0-48.6,37.3-83.4,87.6-83.4,27.9,0,51.2,10.1,66.4,28.6l-24,22.1c-10.8-12.4-24.4-18.9-40.6-18.9-30.2,0-51.6,21.2-51.6,51.6s21.4,51.6,51.6,51.6c16.1,0,29.7-6.5,40.6-19.1l24,22.1c-15.2,18.7-38.5,28.8-66.6,28.8C247.3,183.4,209.9,148.6,209.9,100Z",
    transform: "translate(0 -16.5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M375.2,164.8l12.7-28.1c13.6,9.9,33.9,16.8,53.2,16.8,22.1,0,31.1-7.4,31.1-17.3,0-30.2-93.8-9.5-93.8-69.4,0-27.4,22.1-50.3,68-50.3,20.3,0,41,4.8,56,14.3L490.9,59.2c-15-8.5-30.4-12.7-44.7-12.7-22.1,0-30.7,8.3-30.7,18.4,0,29.7,93.8,9.2,93.8,68.5,0,27-22.4,50-68.5,50C415.3,183.4,389.5,175.8,375.2,164.8Z",
    transform: "translate(0 -16.5)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M644,97.5h34.1V163c-17.7,13.4-42.2,20.5-65.2,20.5-50.7,0-88.1-34.8-88.1-83.4s37.3-83.4,88.7-83.4c28.4,0,51.9,9.7,67.5,27.9L657,66.7c-11.8-12.4-25.4-18.2-41.7-18.2-31.3,0-52.8,21-52.8,51.6,0,30.2,21.4,51.6,52.3,51.6,10.1,0,19.6-1.8,29-6.9V97.5Z",
    transform: "translate(0 -16.5)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M821.7,97.5h34.1V163c-17.7,13.4-42.2,20.5-65.2,20.5-50.7,0-88.1-34.8-88.1-83.4s37.3-83.4,88.7-83.4c28.4,0,51.9,9.7,67.5,27.9l-24,22.1C822.9,54.3,809.3,48.5,793,48.5c-31.3,0-52.8,21-52.8,51.6,0,30.2,21.4,51.6,52.3,51.6,10.1,0,19.6-1.8,29-6.9V97.5Z",
    transform: "translate(0 -16.5)"
  })));
};

export default SvgLogoText;